import { getColorTones } from '../../../utils';
import { brandColors } from './brand';

const { brandOne, brandTwo, brandThree } = brandColors;

export const brandToneColors = {
  ...getColorTones(brandOne, 'brandOne'),
  ...getColorTones(brandTwo, 'brandTwo'),
  ...(brandThree ? getColorTones(brandThree, 'brandThree') : {}),
} as const;
